export type Testimonial = {
  quote: string
  name: string
  country: string
  photo: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Prima improvvisavo tutto: preventivi, garanzie e perfino gli incassi. Oggi ho un processo chiaro e i miei clienti mi prendono molto più sul serio.',
    name: 'Carlos R.',
    country: 'Colombia',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/a0615a36-7f85-452b-a057-dda271452126.jpg',
  },
  {
    quote:
      'Solo il Sistema #6 vale molto più di quello che ho pagato. Avere tutti i modelli pronti mi ha fatto risparmiare settimane di lavoro.',
    name: 'Miguel G.',
    country: 'Messico',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/f9ad1169-c55f-4a89-96f4-2eae4d4f725f.jpg',
  },
  {
    quote:
      'Ho scoperto che stavo perdendo denaro in quasi tutte le mie riparazioni perché non calcolavo i miei costi. Il Sistema Guadagno Reale ha cambiato il mio modo di stabilire i prezzi.',
    name: 'José L.',
    country: 'Venezuela',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/0a83ce67-5a91-4929-83fb-d7faa28a4216.jpg',
  },
]
